

import { useState } from 'react';
import useDebugDoubleD from '../effects/useDebugDoubleD';

function stringify(data) {
    const json = JSON.stringify(data, (key, value) => {
        if (key === 'store') return undefined;
        if (key === 'product') return undefined;
        if (key === 'owner') return undefined;
        if (key === 'configurationOption') return undefined;
        // if (key === 'product') return undefined;
        return value;
    }, 4);
    return json;
}

export default function Debugger({ data, title = 'Debugger', isOpen: defaultIsOpen = true, style = {} }) {
    const [isOpen, setIsOpen] = useState(defaultIsOpen);
    const [isDebugEnabled, setIsDebugEnabled] = useDebugDoubleD(false);

    if (!isDebugEnabled) return null;

    return (
        <div style={{
            ...style,
            marginBlock: 2
        }}>
            <div
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    cursor: 'pointer',
                    padding: '0px 3px',
                    // backgroundColor: 'rgba(0,0,0,0.2)',
                    color: 'black',
                    fontSize: '12px',
                    // fontWeight: 'bold',
                    userSelect: 'none'
                }}
            >
                {isOpen ? '▼' : '▶'} {title}
            </div>
            {isOpen && <pre style={{
                fontSize: 9,
                lineHeight: 1.2,
                fontFamily: 'Consolas, monospace',
                overflow: 'scroll',
                backgroundColor: 'rgba(210,210,210,1)',
                padding: 8,
                maxHeight: 400,
            }}>
                {stringify(data)}
            </pre>}
        </div>
    );
}